const mutations = {
  SET_ACCESS_TOKEN (state, payload) {
    state.accessToken = payload
  },
  SET_CURRENT_USER_ROLE (state, payload) {
    state.currentUserRole = payload
  },
  SET_USER (state, payload) {
    state.user = payload
  },
  SET_PERMISSION (state, payload) {
    state.permission = payload
  },
  SET_ALL_PERMISSION (state, payload) {
    state.allPermission = payload
  },
  SET_USER_ROLE (state, payload) {
    state.currentUserRole = payload
  },
  SET_ROLES (state, payload) {
    state.roles = payload
  },
  SET_ISSUE_TYPES (state, payload) {
    state.issueTypes = payload
  },
  SET_ISSUE_STATUSES (state, payload) {
    state.issueStatuses = payload
  },
  SET_USER_NAME (state, payload) {
    state.currentUserName = payload
    localStorage.setItem('user_name', payload)
  },
  SET_USER_ID (state, id) {
    state.currentUserId = id
  },
  SET_ALL_USERS (state, payload) {
    state.allUsers = payload
  },
  SET_ACTIVE (state, payload) {
    state.isActive = payload
  },
  SET_NOT_ESTIMATED_ISSUES (state, payload) {
    state.notEstimatedIssues = [ ...payload ]
  },
  SET_NOT_BUDGET_ISSUES (state, payload) {
    state.notBudgetIssues = [ ...payload ]
  },
  SET_EXPENSES_CATEGORIES (state, payload) {
    state.expensesCategories = [ ...payload ]
  },
  SET_EXPENSES_STATUSES (state, payload) {
    state.expensesStatuses = [ ...payload ]
  },
  SET_CURRENCIES (state, payload) {
    state.currencies = [ ...payload ]
  },
  SET_BANK_CARDS (state, payload) {
    state.bankCards = [ ...payload ]
  },
  SET_OWN_BANK_DETAILS (state, payload) {
    state.ownBankDetails = [ ...payload ]
  },
  TOGGLE_SIDEBAR (state, payload) {
    state.showSidebar = payload
  },
  IS_JIRA_AUTH (state, payload) {
    state.isJiraAuth = payload
  }
}

export default mutations
